import type React from "react";
import "./ToggleSwitch.scss";

export type ToggleSwitchProps = {
  id?: string;
  name?: string;
  checked?: boolean; // controlled
  defaultChecked?: boolean; // uncontrolled
  onChange?: (checked: boolean, ev: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  name,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  className,
}) => {
  const classes = ["toggle-switch", disabled ? "toggle-switch--disabled" : "", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <input
        id={id}
        name={name}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={(e) => onChange?.(e.target.checked, e)}
      />
      <span className="toggle-switch__slider" />
    </div>
  );
};

export default ToggleSwitch;
